export default {"src":"/uk/_next/static/media/spot-expert-approved.194f87d3.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};